import React from "react";

const STRATEGIES = {
  REBALANCE: "rebalance",
  GRID: "grid",
  XENO_ARC: "xeno arc",
  XENO_V3: "xeno bot v3",
  DCA: "dca",
};

const botDetails = {
  [STRATEGIES.REBALANCE]: {
    description: "text1",
    iconColor: "bg-blue-200", // Example color
  },
  [STRATEGIES.DCA]: {
    description: "text2",
    iconColor: "bg-green-200", // Example color
  },
  [STRATEGIES.XENO_ARC]: {
    description:
      "An upgraded Grid strategy with smarter timing. Xenoarc filters trades by waiting for bounce or reversal signals—reducing noise, avoiding bad entries, and boosting precision in volatile markets.",
    iconColor: "bg-[#B2B7DE]",
  },
  [STRATEGIES.GRID]: {
    description:
      "A classic strategy for profiting from price swings. It places buy and sell orders in a grid to capture gains from small moves—up or down. Best for sideways markets, with steady, stress-free automation.",
    iconColor: "bg-[#FAC482]",
  },
  // Add other strategies here
};

const BotLogo = ({
  size = 40,
  iconColor = "bg-gray-200",
  src = "/images/icons/icon_testing_mode.png",
  alt = "Bot logo",
  className = "",
  classNameLogo = "",
  botName,
}) => {
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full ${
        botName ? botDetails[botName?.toLowerCase()]?.iconColor : iconColor
      } ${className}`}
    >
      <img
        src={src}
        alt={alt}
        // style={{ height: `${size}px`, width: "100%", maxWidth: `${size}px` }}
        // The image scales proportionally within the container
        className={`h-[${size}px] w-full max-w-[${size}px] ${classNameLogo}`}
        // className="h-full w-full object-contain p-1.5"
      />
    </div>
  );
};

export default BotLogo;
